// extracted by mini-css-extract-plugin
export default {"reviews":"Reviews_reviews__4laub","reviewsContainer":"Reviews_reviewsContainer__a5H-1"};